import api from 'api';

const citiesUrl = 'api/cities';
const filteredCitiesUrl = '/api/cities';

export default {
    fetch: params => api.get({path: citiesUrl, params}),
    filteredFetch: filter => api.get({path: filteredCitiesUrl, params: {word:filter}})
}